(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  
  function initSlideshow() {
    const slideshows = document.querySelectorAll('layered-slideshow-component');
    
    slideshows.forEach(function(slideshow) {
      if (slideshow.dataset.initialized) return;
      slideshow.dataset.initialized = 'true';
      
      const slides = slideshow.querySelectorAll('.layered-slideshow__slide');
      const dots = slideshow.querySelectorAll('.layered-slideshow__dot');
      const prevButton = slideshow.querySelector('.layered-slideshow__arrow--prev');
      const nextButton = slideshow.querySelector('.layered-slideshow__arrow--next');
      
      let currentSlide = 0;
      const totalSlides = slides.length;
      
      console.log('Slideshow initialisé avec', totalSlides, 'slides');
      
      if (totalSlides === 0) {
        console.error('Aucune slide trouvée!');
        return;
      }
      
      function goToSlide(index) {
        if (index < 0 || index >= totalSlides) return;
        
        console.log('Aller à la slide', index);
        
        slides[currentSlide].classList.remove('is-active');
        if (dots[currentSlide]) {
          dots[currentSlide].classList.remove('is-active');
        }
        
        currentSlide = index;
        
        slides[currentSlide].classList.add('is-active');
        if (dots[currentSlide]) {
          dots[currentSlide].classList.add('is-active');
        }
      }
      
      function goToNextSlide() {
        const nextIndex = (currentSlide + 1) % totalSlides;
        goToSlide(nextIndex);
      }
      
      function goToPrevSlide() {
        const prevIndex = (currentSlide - 1 + totalSlides) % totalSlides;
        goToSlide(prevIndex);
      }
      
      if (prevButton) {
        prevButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          console.log('Clic sur flèche précédente');
          goToPrevSlide();
        });
      }
      
      if (nextButton) {
        nextButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          console.log('Clic sur flèche suivante');
          goToNextSlide();
        });
      }
      
      dots.forEach(function(dot, index) {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          console.log('Clic sur dot', index);
          goToSlide(index);
        });
      });
      
      let touchStartX = 0;
      let touchEndX = 0;
      
      slideshow.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      
      slideshow.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        
        if (touchEndX < touchStartX - 50) {
          console.log('Swipe gauche détecté');
          goToNextSlide();
        }
        if (touchEndX > touchStartX + 50) {
          console.log('Swipe droite détecté');
          goToPrevSlide();
        }
      }, { passive: true });
      
      goToSlide(0);
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlideshow);
  } else {
    initSlideshow();
  }
  
  document.addEventListener('shopify:section:load', initSlideshow);
  document.addEventListener('shopify:section:reorder', initSlideshow);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
